document.addEventListener('DOMContentLoaded', () => {

  const revealLayers = document.querySelectorAll('.revealer__layer');
  const reveals = document.querySelector('.image-reveal');
  const heroSection = document.querySelector('.section--hero-fold');
  const restartButton = document.querySelector('#restart-greeting');
  const greeting = document.querySelector('.hero-greeting');

  if (!greeting) return;

  const container = greeting.querySelector('.hero-greeting__words');

  const words = [
    ...container.querySelectorAll('.hero-greeting__word')
  ];

  const TOTAL = words.length;
  const CENTER = Math.floor(TOTAL / 2);

  const REVEAL_DELAY = 100;
  const MOVE_DURATION = 300;
  const START_DELAY = 150;

  const visible = [];

  let animationId = 0;
  let resizeTimer;


  // ----------------------------------
  // Wait
  // ----------------------------------

  function wait(ms) {
    return new Promise(resolve => {
      setTimeout(resolve, ms);
    });
  }


  // ----------------------------------
  // Generate outside-in reveal order
  // ----------------------------------

  const revealOrder = [];

  for (let i = 0; i < Math.ceil(TOTAL / 2); i++) {

    revealOrder.push(i);

    const opposite = TOTAL - 1 - i;

    if (opposite !== i) {
      revealOrder.push(opposite);
    }

  }


  // ----------------------------------
  // Width = width of Hello
  // ----------------------------------

  function updateWidth() {

    const hello = words[CENTER];

    const width = hello.getBoundingClientRect().width;

    container.style.width = `${Math.ceil(width)}px`;

  }


  // ----------------------------------
  // Get vertical step
  // ----------------------------------

  function getStep() {

    const styles = getComputedStyle(greeting);

    const height = parseFloat(
      styles.getPropertyValue('--word-height')
    );

    const gap = parseFloat(
      styles.getPropertyValue('--word-gap')
    );

    return height + gap;

  }


  // ----------------------------------
  // Update word positions
  // ----------------------------------

  function updatePositions() {

    const step = getStep();

    visible.sort((a, b) => a - b);

    const center = (visible.length - 1) / 2;

    visible.forEach((index, position) => {

      const offset = (position - center) * step;

      words[index].style.setProperty(
        '--offset',
        `${offset}px`
      );

    });

  }


  // ----------------------------------
  // Reset
  // ----------------------------------

  function resetIntro() {

    // Invalidates currently running animation
    animationId++;

    visible.length = 0;

    greeting.classList.remove('intro-complete');

    if (heroSection) {
      heroSection.classList.remove('intro-complete');
    }

    resetImageReveal();

    container.style.width = '0px';

    words.forEach(word => {

      word.classList.remove(
        'is-visible',
        'is-center'
      );

      word.style.setProperty('--offset', '0px');

    });

  }


  // ----------------------------------
  // Insert word
  // ----------------------------------

  async function insertWord(index, currentAnimationId) {

    // Animation was cancelled
    if (currentAnimationId !== animationId) {
      return false;
    }

    const word = words[index];

    visible.push(index);

    // New word starts in center
    word.style.setProperty('--offset', '0px');

    word.classList.add('is-visible');

    // Force initial position to render
    void word.offsetHeight;

    requestAnimationFrame(() => {

      if (currentAnimationId !== animationId) {
        return;
      }

      updatePositions();

    });

    await wait(REVEAL_DELAY);

    return currentAnimationId === animationId;

  }


  // ----------------------------------
  // Run animation
  // ----------------------------------

  async function runIntro() {

    resetIntro();

    const currentAnimationId = animationId;

    // Wait for fonts before measuring Hello
    if (document.fonts) {
      await document.fonts.ready;
    }

    // Make sure this animation hasn't
    // already been cancelled
    if (currentAnimationId !== animationId) {
      return;
    }

    // Register collapsed state
    void container.offsetWidth;

    updateWidth();

    await wait(START_DELAY);

    if (currentAnimationId !== animationId) {
      return;
    }


    // ----------------------------------
    // Reveal outside -> center
    // ----------------------------------

    for (const index of revealOrder) {

      const shouldContinue = await insertWord(
        index,
        currentAnimationId
      );

      if (!shouldContinue) {
        return;
      }

    }


    // ----------------------------------
    // Wait for words to finish moving
    // ----------------------------------

    await wait(MOVE_DURATION);

    if (currentAnimationId !== animationId) {
      return;
    }


    // ----------------------------------
    // Hello
    // ----------------------------------

    words[CENTER].classList.add('is-center');


    // ----------------------------------
    // Say + to Affinity
    // ----------------------------------

    greeting.classList.add('intro-complete');

    if (heroSection) {
      heroSection.classList.add('intro-complete');
    }

    if (restartButton) {
      restartButton.disabled = false;
    }


    // ----------------------------------
    // Image reveal
    // ----------------------------------

    await wait(1000);

    if (currentAnimationId !== animationId) {
      return;
    }

    revealImage();

  }


  // ----------------------------------
  // Initial run
  // ----------------------------------

  runIntro();


  // ----------------------------------
  // Window resize
  // ----------------------------------
  let lastWidth = window.innerWidth;
  window.addEventListener('resize', () => {
    if (window.innerWidth === lastWidth) {
      // Ignore resize event if width has not changed
      return;
    }
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      runIntro();
    }, 250);
  });


  // ----------------------------------
  // Restart button
  // ----------------------------------

  if (restartButton) {

    restartButton.addEventListener('click', () => {
      runIntro();
    });

  }


  // ----------------------------------
  // Image reveal
  // ----------------------------------

  function revealImage() {

    if (!reveals) return;

    revealLayers.forEach(layer => {
      layer.classList.add('revealed');
    });

    setTimeout(() => {

      reveals.classList.add('revealed');

      const scrollDownLink = document.querySelector(
        '.scroll-down-link'
      );

      if (scrollDownLink) {
        scrollDownLink.classList.add('in');
      }

    }, 750);

  }


  // ----------------------------------
  // Reset image reveal
  // ----------------------------------

  function resetImageReveal() {

    if (!reveals) return;

    revealLayers.forEach(layer => {
      layer.classList.remove('revealed');
    });

    reveals.classList.remove('revealed');

    const scrollDownLink = document.querySelector(
      '.scroll-down-link'
    );

    if (scrollDownLink) {
      scrollDownLink.classList.remove('in');
    }

  }


  // ----------------------------------
  // Scroll to section
  // ----------------------------------

  function scrollToSection(target, duration = 1000) {

    const el = typeof target === 'string'
      ? document.querySelector(target)
      : target;

    if (!el) return;

    const startY = window.scrollY;

    const targetY =
      el.getBoundingClientRect().top + startY;

    const distance = targetY - startY;

    const startTime = performance.now();


    // cubic-bezier style easing
    // easeInOutCubic
    const ease = t =>
      t < 0.5
        ? 4 * t * t * t
        : 1 - Math.pow(-2 * t + 2, 3) / 2;


    function animate(currentTime) {

      const elapsed = currentTime - startTime;

      const progress = Math.min(
        elapsed / duration,
        1
      );

      window.scrollTo(
        0,
        startY + distance * ease(progress)
      );

      if (progress < 1) {
        requestAnimationFrame(animate);
      }

    }

    requestAnimationFrame(animate);

  }


  // ----------------------------------
  // Section links
  // ----------------------------------

  const links = document.querySelectorAll('.section-link');

  links.forEach(link => {

    link.addEventListener('click', e => {

      const target = document.querySelector(
        link.hash
      );

      if (!target) return;

      e.preventDefault();

      scrollToSection(target, 1000);

    });

  });


  // ----------------------------------
  // Video
  // ----------------------------------
  function hasMarketingConsent() {
    return window.Cookiebot?.consent?.marketing === true;
  }

  const playButton = document.querySelector('#play-button');
  const video = document.querySelector('#meet-video');
  if (playButton && video) {
    playButton.addEventListener('click', () => {
      const iframe = video.querySelector('iframe');
      if(!hasMarketingConsent()) { //cookies denied
        if(iframe) iframe.remove(); //then remove the iframe
      } else {
        if(!iframe) {
          const src = video.dataset.videoSrc;
          if(!src) return;
          //crate the iframe
          const iframe = document.createElement('iframe');
          const url = new URL(src);
          url.searchParams.set('autoplay', '1');
          iframe.src = url;
          iframe.setAttribute('allow',
              'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen'
          );
          video.classList.add('playing');
          video.appendChild(iframe);
        }

      }
    });
  }

  //media gallery
  const media = document.querySelectorAll('.media');
  const downloadPhotoBtn = document.querySelector('#download-photography');
  if(media) {
    let gallery = [];
    media.forEach(img => {
      gallery.push(
        {
          src: img.src,
          thumb: img.src,
          subHtml: img.title
        }
      )
    });
    if(gallery.length > 0) {
      galleryInstance = lightGallery(document.getElementById('media-gallery'), {
        licenseKey: 'LIG-C8B0919B-F014-41FE-8E0D-E69533EF93C7',
        autoplayFirstVideo: false,
        autoplayVideoOnSlide: false,
        backdropDuration: 200,
        download: true,
        dynamic: true,
        dynamicEl: gallery,
        enableSwipe: gallery.length > 1,
        enableDrag: gallery.length > 1,
        hideScrollbar: true,
        mobileSettings: {
          controls: true,
          showCloseIcon: true,
        },
        plugins: [lgThumbnail, lgVideo],
        selector: '.gallery-media',
        startAnimationDuration: 200,
        strings: {
          closeGallery: 'Close Gallery'
        },
        subHtmlSelectorRelative: true,
        videoMaxSize: "1920-1080",
        vimeoPlayerParams: {
          autoplay: 0,
        },
        youtubePlayerParams: {
          autoplay: 0,
          modestbranding: 1,
        },
        zoomFromOrigin: false,
      });
    }
  }

  downloadPhotoBtn.addEventListener('click', (e)=>{
    e.preventDefault();
    galleryInstance.openGallery();
  })
}); //DOM Loaded

window.addEventListener('CookiebotOnDecline', (e)=>{
  if(!Cookiebot.consent.marketing) {
    const video = document.querySelector('#meet-video');
    const iframe = video.querySelector('iframe');
    if(video) video.classList.remove('playing')
    if(iframe) iframe.remove();
  }
});
